export default __webpack_public_path__ + "static/media/you.456799cd.svg";